<template>
  <div>
    <h1 class="header-style">
      Workers
    </h1>
    <p class="subheader-style">
      List of all workers
    </p>
    <div>
      <v-tabs
        v-model="tab"
        class="tab-style mt-5"
        rounded
        color="transparent"
        active-class="selected-tab"
        light
      >
        <v-tab
          class="tab-accepted"
          @click="createButtonVisibility = true"
        >
          <v-icon size="15">
            mdi-check-circle-outline
          </v-icon>
          Accepted
        </v-tab>
        <v-tab
          class="tab-pending"
          @click="createButtonVisibility = false"
        >
          <v-icon size="15">
            mdi-clock-outline
          </v-icon>
          Pending
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="my-tabs-background-style"
        touchless
      >
        <v-tab-item>
          <v-card-text>
            <accepted-app-users-list
              ref="appusers"
              @app-user-role="setAppUser"
            />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <pending-app-users-list />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items><br><br>
    </div>
    <create-new-worker
      v-if="showModal"
      :selected-org-id="selectedOrgId"
      :app-user-role="appUserRole"
      :selected-company="selectedCompany"
      @closed="showModal = false"
    />
  </div>
</template>

<script>
import AcceptedAppUsersList from './dialogComponents/appuserDialogs/AcceptedAppUsersList.vue';
import PendingAppUsersList from './dialogComponents/appuserDialogs/PendingAppUsersList.vue';
import AppUserCreateForm from './dialogComponents/appuserDialogs/AppUserCreateForm.vue';
export default {
  name: 'AppUsersPage',
  components: {
    'accepted-app-users-list': AcceptedAppUsersList,
    'pending-app-users-list': PendingAppUsersList,
    'create-new-worker': AppUserCreateForm,
  },
  data: () => ({
    tab: null,
    selectedOrgId: '',
    showModal: false,
    appUserRole: '',
    selectedCompany: '',
    createButtonVisibility: true,
  }),
  computed: {
    checkWorker () {
     if (this.appUserRole === 'worker' || this.createButtonVisibility === false) {
      return true;
     }
     return false;
    },
    appUserOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationsAvailable () {
      if (this.appUserOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.setAppUser();
  },
  methods: {
    setAppUser (appUserRole, org, company) {
      this.appUserRole = appUserRole === undefined ? null : appUserRole;
      this.selectedCompany = company === undefined ? null : company;
      this.selectedOrgId = org === undefined ? null : org;
    },
  },
};
</script>

<style scoped>

.floating-add-button {
  position: fixed;
  bottom: 70px !important;
  right: 10px;
  z-index: 1;
}
.my-tabs-background-style {
  background-color: transparent;
}
.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}
.v-slide-group__content v-tabs-bar__content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.v-tabs-slider-wrapper {
  background-color: transparent !important;
}
.v-tab {
  color: #000000 !important;
  border-radius: 10px;
  height: 30px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  gap: 10px;
  background: #FFF;
}

.v-tab.tab-pending {
  width: 40% !important;
  border: 1px solid #ffca68;
}

.v-tab--active.tab-pending {
  color: #ffffff !important;
  background: #ffca68;
  border: none;
}

.v-tab.tab-accepted {
  width: 40% !important;
  border: 1px solid #63ca7f;
}

.v-tab--active.tab-accepted {
  color: #ffffff !important;
  background: #63ca7f;
  border: none;
}
.selected-tab {
  color: #fff;
}
.v-tab {
  font-size: 12px !important;
}
.theme--dark.v-list {
  background-color: white !important;
}
.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
.spacing-container {
  padding-right: 12px;
  padding-left: 12px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.v-application .primary--text {
  color: #37474f !important;
}
.v-card__text {
  padding: 0px;
}
</style>
